import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';
import contactInfo from '../../data/contactInfo.json';
import LegalModal from '../legalModal/legalModal';

function Footer() {
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);

  const formatTelephoneForLink = (telephone) => {
    return telephone.replace(/[.\s]/g, '');
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-content">
          <div className="footer-section">
            <h4 className="footer-section__title">Contact</h4>
            <ul className="footer-section__list">
              <li>
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </li>
              <li>
                <a href={`tel:${formatTelephoneForLink(contactInfo.telephone)}`}>
                  {contactInfo.telephone}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-section__title">Adresse</h4>
            <ul className="footer-section__list">
              <li>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactInfo.adresse)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contactInfo.adresse}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-section__title">Suivez-nous</h4>
            <ul className="footer-section__list">
              <li>
                <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer">
                  Facebook
                </a>
              </li>
              <li>
                <a href={contactInfo.instagram} target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-bottom__copy">
            &copy; {new Date().getFullYear()} La Houblonnière de Lezerzot
          </p>
          <div className="footer-bottom__links">
            <button
              type="button"
              className="footer-bottom__link"
              onClick={() => setIsLegalModalOpen(true)}
            >
              Mentions légales
            </button>
            <span className="footer-bottom__sep" aria-hidden="true">·</span>
            <Link to="/admin" className="footer-bottom__link">
              Connexion
            </Link>
          </div>
        </div>
      </div>

      <LegalModal
        isOpen={isLegalModalOpen}
        onClose={() => setIsLegalModalOpen(false)}
      />
    </footer>
  );
}

export default Footer;
